const initialState = {
  stepCompleted: false,
  witness: null
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_WITNESS': {
      return {
        ...state,
        witness: action.payload.witness,
        stepCompleted: true
      }
    }

    default: {
      return state
    }
  }
}
